export default {
  key: "advertisement",
  basePath: "/advertisement",
  exclude: false,
  components: [
    {
      name: "banner",
      component: () => import("./components/banner"),
    },
    {
      name: "bottom-banner",
      component: () => import("./components/bottom_banner"),
    },
    {
      name: "middle-offer",
      component: () => import("./components/middle_offer"),
    },
    {
      name: "offer",
      component: () => import("./components/offer"),
    },
    {
      name: "top-banner",
      component: () => import("./components/top_banner"),
    },
    {
      name: "fashion-banner",
      component: () => import("./components/fashion-banner"),
    },
    {
      name: "grocery-banner",
      component: () => import("./components/grocery_banner"),
    },
    {
      name: "middle-banner",
      component: () => import("./components/eparisheva_home-middle1.vue"),
    },
    {
      name: "fashion-middle",
      component: () => import("./components/fashion-middle"),
    },
    {
      name: "top-banner-text",
      component: () => import("./components/top_banner_text"),
    },
    {
      name: "loading",
      component: () => import("./components/loading"),
    },
    {
      name: "home-offer",
      component: () => import("./components/home_offer"),
    },
    {
      name: "home-offer-middle",
      component: () => import("./components/home_offer_middle"),
    },
    
  ],
};
